import { GroupCollapse, type GroupCollapseItem } from '@protector/components';
import type { FlightPredictionRowWithExtras } from '@features/regional-overview/digital-traps/domain/flight-prediction.models';
import {
  DAILY_COUNTS_NETWORK_GROUP_CARD,
  DAILY_COUNTS_PREDICTIONS_CARD_LIST
} from '@features/regional-overview/digital-traps/domain/tests-id.constants';
import { generateFlightPredictionColumnsAndKeys } from '@features/regional-overview/digital-traps/utils';
import { useTranslation } from 'react-i18next';
import { DailyCountsPredictionsTrapCard } from '../daily-counts-predictions-trap-card';
import styles from './daily-counts-predictions-card-list.module.css';

interface DailyCountsPredictionsCardListProps {
  networks: { title: string; key: string; tableDataSource: FlightPredictionRowWithExtras[] }[];
}

export const DailyCountsPredictionsCardList = ({ networks }: DailyCountsPredictionsCardListProps) => {
  const [t] = useTranslation();
  const { dateTableColumns } = generateFlightPredictionColumnsAndKeys({ t });
  const dates = dateTableColumns.map(column => (typeof column.title === 'string' ? column.title : ''));

  const collapseItems: GroupCollapseItem[] = networks.map(group => ({
    key: group.key,
    title: group.title,
    headerTestId: DAILY_COUNTS_NETWORK_GROUP_CARD,
    children: (
      <ul className={styles.cardList}>
        {group.tableDataSource.map(record => (
          <li className={styles.cardListItem} key={record.id}>
            <DailyCountsPredictionsTrapCard record={record} dates={dates} />
          </li>
        ))}
      </ul>
    )
  }));

  return (
    <section className={styles.cardListSection} data-testid={DAILY_COUNTS_PREDICTIONS_CARD_LIST}>
      <GroupCollapse items={collapseItems} />
    </section>
  );
};
